import { useApolloClient } from '@apollo/client/react';
import { Box, CircularProgress } from '@mui/material';
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAPI } from 'src/api/provider';
import { GetMeDocument } from 'src/graphql/client';
import { StringParam, useQueryParam } from 'src/helpers/queryParam';
import { InvalidMagicLink } from './InvalidMagicLink';

const ConsumingMagicLink = () => {
    const { t } = useTranslation('auth.magicLink');
    return (
        <Grid
            container
            alignItems="center"
            justifyContent="center"
            direction="column"
            style={{ minHeight: '100vh' }}
        >
            <CircularProgress size={100} />
            <Box my={4}>{t('processingLoginLink')}</Box>
        </Grid>
    );
};

export const MagicLinkConsumer = ({ children }: { children: React.ReactNode }) => {
    const apolloClient = useApolloClient();
    const apiClient = useAPI();

    const [loginFailed, setLoginFailed] = useState(false);
    const [username, setUsername] = useQueryParam('username', StringParam);
    const [token, setToken] = useQueryParam('magic_link_token', StringParam);

    useEffect(() => {
        if (!token) {
            return;
        }
        (async () => {
            try {
                await apiClient.post('/magic-link-login/', { token });
                apolloClient.query({
                    query: GetMeDocument,
                    fetchPolicy: 'network-only',
                });
            } catch {
                setLoginFailed(true);
            }
        })();
        return () => {
            setToken(undefined);
            setUsername(undefined);
        };
    }, [apiClient, apolloClient, token, setToken, setUsername]);

    if (token) {
        return loginFailed ? (
            <InvalidMagicLink initialUsername={username || ''} />
        ) : (
            <ConsumingMagicLink />
        );
    }

    return <>{children}</>;
};
